__turbopack_context__.v({
  "ctaBanner": "cta-inline-module__cWnnRG__ctaBanner",
  "ctaContent": "cta-inline-module__cWnnRG__ctaContent",
  "ctaLink": "cta-inline-module__cWnnRG__ctaLink",
  "ctaSection": "cta-inline-module__cWnnRG__ctaSection",
});
